<template>
  <div>
    <b-alert v-if="!hideTz" show class="py-0 text-center" size="sm">{{ timezone }}</b-alert>

    <b-form-input
        type="datetime-local"
        :value="localDateTimeString"
        size="sm"
        :state="state"
        placeholder="Select date and time"
        @input="onDateTimeInput"
    />
  </div>
</template>

<script setup>
import {ref, computed, watchEffect} from 'vue'
import {DateTime} from 'luxon'

const props = defineProps({
  value: {
    type: String, // UTC ISO string
    default: null,
  },
  timezone: {
    type: String,
    default: 'local',
  },
  state: {
    type: [String, Boolean],
    default: undefined,
  },
  hideTz: Boolean,
})

const emit = defineEmits(['input'])

const localDateTime = ref(null)

watchEffect(() => {
  if (!props.value) {
    localDateTime.value = null
    return
  }

  const dt = DateTime.fromISO(props.value, {zone: 'utc'}).setZone(props.timezone || 'local')
  localDateTime.value = dt.isValid ? dt : null
})

const localDateTimeString = computed(() => {
  return localDateTime.value
      ? localDateTime.value.toFormat("yyyy-LL-dd'T'HH:mm")
      : null
})

function onDateTimeInput(str) {
  if (!str) {
    localDateTime.value = null
    emit('input', null)
    return
  }

  const dt = DateTime.fromFormat(str, "yyyy-LL-dd'T'HH:mm", {
    zone: props.timezone || 'local'
  })

  if (dt.isValid) {
    localDateTime.value = dt
    emit('input', dt.toUTC().toISO())
  }
}
</script>
